export const ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS';
export const ADD_ADDRESS_REQUEST = 'ADD_ADDRESS_REQUEST';
export const ADD_ADDRESS_FAILURE = 'ADD_ADDRESS_FAILURE';
export const ADD_ADDRESS_RESET = 'ADD_ADDRESS_RESET';
export const addAddressSuccess = (payload) => ({
    type: ADD_ADDRESS_SUCCESS,
    payload,
});
export const addAddressRequest = (payload) => ({
    type: ADD_ADDRESS_REQUEST,
    payload,
});
export const addAddressFailure = (payload) => ({
    type: ADD_ADDRESS_FAILURE,
    payload,
});
export const addAddressReset = () => ({
    type: ADD_ADDRESS_RESET,
});
